"use strict";

const loggedUserHasRoles = (userRoles, roles) => {
  return (
    userRoles.filter(userRole => roles.find(role => role == userRole)).length >
    0
  );
};

export default {
  loggedUserHasRoles
};
